module.exports = __webpack_public_path__ + "static/media/hcr-ffpe-human-pancreas.0ef600d9.jpg";


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/images/hcr-ffpe-human-pancreas.jpg
// module id = 1384
// module chunks = 0